import {
  BarChart3,
  BrainCircuit,
  Megaphone,
  MousePointerClick,
  ScanSearch,
  ShoppingCart,
  Target,
  Zap,
  type LucideIcon,
} from 'lucide-react'

export type ServiceCategoryVariant =
  | 'indigo'
  | 'violet'
  | 'blue'
  | 'amber'
  | 'teal'
  | 'emerald'
  | 'rose'
  | 'orange'

export type ServiceCategoryTab = {
  slug: string
  label: string
  Icon: LucideIcon
  iconColor: string
  variant: ServiceCategoryVariant
  tip: string
}

export const SERVICE_CATEGORY_TABS: ServiceCategoryTab[] = [
  {
    slug: 'smart-audits',
    label: 'Smart Audits',
    Icon: ScanSearch,
    iconColor: 'text-indigo-500',
    variant: 'indigo',
    tip: 'Technical audits that surface what’s broken before you spend more.',
  },
  {
    slug: 'ai',
    label: 'AI',
    Icon: BrainCircuit,
    iconColor: 'text-violet-500',
    variant: 'violet',
    tip: 'Workflows, widgets, and AI systems that connect traffic to revenue.',
  },
  {
    slug: 'analytics',
    label: 'Analytics',
    Icon: BarChart3,
    iconColor: 'text-blue-500',
    variant: 'blue',
    tip: 'GA4, GTM, and server-side tracking so you can see what actually converts.',
  },
  {
    slug: 'marketing',
    label: 'Marketing',
    Icon: Megaphone,
    iconColor: 'text-amber-500',
    variant: 'amber',
    tip: 'Google, Meta, and paid search. Built, audited, and tracked to revenue.',
  },
  {
    slug: 'seo',
    label: 'SEO',
    Icon: Zap,
    iconColor: 'text-teal-500',
    variant: 'teal',
    tip: 'Technical SEO and AI search visibility so the right pages get found.',
  },
  {
    slug: 'cro',
    label: 'CRO',
    Icon: MousePointerClick,
    iconColor: 'text-emerald-500',
    variant: 'emerald',
    tip: 'Landing page and funnel tests that lift conversion without extra spend.',
  },
  {
    slug: 'leadgen',
    label: 'Lead Gen',
    Icon: Target,
    iconColor: 'text-rose-500',
    variant: 'rose',
    tip: 'Capture and route demand with forms, widgets, and CRM handoff.',
  },
  {
    slug: 'ecommerce',
    label: 'E-commerce',
    Icon: ShoppingCart,
    iconColor: 'text-orange-500',
    variant: 'orange',
    tip: 'Feeds, shopping, and store tracking so product revenue is visible.',
  },
]
